/* eslint-disable @typescript-eslint/no-require-imports */
import $ from "jquery";

import ko from "knockout";
import * as kv from "knockout.validation";
import "knockout-punches";
import "knockout-sortable";
import "3pp/ko.plus";

import "bootstrap-sass/assets/javascripts/bootstrap";

import "jquery-ui/ui/widgets/autocomplete";
import "jquery-ui/ui/widgets/slider";
import "jquery-ui/ui/widgets/progressbar";
import "jquery-form";
import "ui-contextmenu";

import * as _ from "underscore";

const windowAny = window as any;

windowAny.define("underscore", [], function () {
    return _;
});

// For backwards compatibility with some 3pps that are not in module format.
// signalR is one example
windowAny.jQuery = $;

// Hack to make web modules that require these externally happy.
// They are already loaded, but still want them in polyfill bundle and not common.
// Will revisit when looking into webpack context on Flow itself.
windowAny.define("core-js/stable", [], function () {
    return {};
});
windowAny.define("regenerator-runtime/runtime", [], function () {
    return {};
});

windowAny.define("text", [], function () {
    return require("requirejs-text");
});

// Seems to be an issue with amdDefineLoader and knockout.validation.
// Sometimes it is defined with full path.
// This is to ensure knockout.validation name is always available.
// In worst case we will have to do this for all 3pps hosted by Flow.
windowAny.define("knockout.validation", kv);

ko.punches.enableAll();
